module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BookingsPage"
  }, [_c('Navigation', {
    attrs: {
      "showPromoterNav": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row p-t-6"
  }, [_c('div', {
    staticClass: "p-t-2 col-md-12"
  }, [_c('Card', {
    staticClass: "m-t-5"
  }, [_c('div', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.t('Bookings')))]), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookingCodeFilter),
      expression: "bookingCodeFilter"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Filter by Booking Code"
    },
    domProps: {
      "value": (_vm.bookingCodeFilter)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.bookingCodeFilter = $event.target.value
      }, function($event) {
        _vm.setBookingCodeFilter()
      }]
    }
  }), _vm._v(" "), (_vm.bookings.length === 0) ? _c('div', {
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.t('There are no bookings')))]) : _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v(_vm._s(_vm.t('user')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Dates')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Activity')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Participants')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Status')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Price')))])]), _vm._v(" "), _c('tbody', _vm._l((_vm.bookings), function(booking, index) {
    return _c('tr', {
      staticClass: "booking",
      class: {
        rejected: (booking.state_id === 4), hasHappened: _vm.hasHappened(booking.date)
      }
    }, [_c('td', [_vm._v("\n                    " + _vm._s(booking.user.name)), _c('br'), _vm._v("\n                    " + _vm._s(booking.user.email)), _c('br'), _vm._v("\n                    " + _vm._s(booking.user.phone) + "\n\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "dates"
    }, [_vm._v("\n                    created: "), _c('b', [_vm._v(_vm._s(_vm.toNow(booking.created_at)))]), _vm._v(" ago"), _c('br'), _vm._v("\n                    occurs at: "), _c('b', [_vm._v(_vm._s(booking.date))]), _vm._v(" (in " + _vm._s(_vm.toNow(booking.date)) + ")\n                  ")]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "bookingCode",
      attrs: {
        "to": ("/" + _vm.language + "/bookings/" + (booking.booking_code))
      }
    }, [_vm._v(_vm._s(booking.booking_code) + "\n                    ")]), _c('br'), _vm._v(" "), (booking.promotional_code !== null) ? _c('div', {
      staticClass: "promotionalCode"
    }, [_c('i', {
      staticClass: "fa fa-ticket"
    }), _vm._v(" "), _c('b', [_vm._v("promo code:")]), _vm._v(" " + _vm._s(booking.promotional_code))]) : _vm._e(), _vm._v("\n                    " + _vm._s(booking.activity.translations[_vm.language].name) + "\n                ")], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(booking.persons.length))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.t(booking.state)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(booking.total_price) + " €\n                    "), (booking.state_id === 3) ? _c('span', [(booking.to_be_charged) ? _c('small', [(!_vm.hasHappened(booking.date)) ? _c('span', [_vm._v("(" + _vm._s(_vm.t('Will be charged')) + ")")]) : _c('span', [_vm._v("(" + _vm._s(_vm.t('Has been charged')) + ")")])]) : _c('small', [_vm._v("\n                        (" + _vm._s(_vm.t('Will not be charged')) + ")\n                      ")])]) : _vm._e()]), _vm._v(" "), _c('td', [(!booking.to_be_charged) ? _c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.willBePaidLocal({
            booking_code: booking.booking_code,
            to_be_charged: true
          })
        }
      }
    }, [_vm._v("cobrar")]) : _c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.willBePaidLocal({
            booking_code: booking.booking_code,
            to_be_charged: false
          })
        }
      }
    }, [_vm._v("não cobrar")])])])
  }))])])])], 1)])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7cc8a06f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cc8a06f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/AdminBookings.vue
// module id = 793
// module chunks = 3